if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"fulfillment","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}